export default "__VITE_ASSET__DIVGKGnl__"